
import PropTypes from 'prop-types'

import { formatToCurrency } from '@/utils/format'

import styles from './../../CartItem/Strikethrough/styles.module.scss'

const Price = ({ item, dataSelector }) => {
    const originalPriceSelector = `${dataSelector}_originalPrice`
    const { price, quantity } = item
    const originalPrice = price * quantity

    return (
        <div className={styles.priceContainer}>
            <h4 className={styles.price} data-selector={originalPriceSelector}>{formatToCurrency(originalPrice, {maximumFractionDigits: 0})}</h4>
        </div>
    )
}

Price.propTypes = {
    item: PropTypes.object.isRequired,
    dataSelector: PropTypes.string.isRequired
}

export default Price
